import React, { useState, useEffect } from "react";
import "./Transferotp.css";
import coin from "../assets/Cam2.png";
import logo from "../assets/logo.png";
import API from "../api/api";
import { useNavigate, useLocation } from "react-router-dom";

// Coin icons for receipt
import btc from "../assets/btc.png";
import eth from "../assets/eth.png";
import bnb from "../assets/bnb.png";
import sol from "../assets/sol.png";
import xrp from "../assets/xrp.png";
import doge from "../assets/doge.png";
import ltc from "../assets/ltc.png";
import trx from "../assets/trx.png";
import usdt from "../assets/usdt.png";
import usdttether from "../assets/usdttether.png";

/* ================= WHATSAPP FLOAT COMPONENT ================= */
const WhatsAppFloat = ({ 
  phoneNumber = "15485825756", 
  message = "Hello! I need assistance with transfer verification on InstaCoinXPay.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, '');
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: '#25d366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    ...positionStyles,
    ...style
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`whatsapp-float ${pulseEffect ? 'pulse' : ''} ${className}`}
      style={combinedStyles}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 24 24"
        fill="white"
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.677-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.826 9.826 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411" />
      </svg>
    </a>
  );
};

const coinIcons = {
  btc: btc,
  eth: eth,
  bnb: bnb,
  sol: sol,
  xrp: xrp,
  doge: doge,
  ltc: ltc,
  trx: trx,
  usdtTron: usdt,
  usdtBnb: usdttether,
};

const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);

const Transferotp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    success: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [transferData, setTransferData] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [showReceipt, setShowReceipt] = useState(false);
  const [completedTransfer, setCompletedTransfer] = useState(null);
  const [resendTimer, setResendTimer] = useState(0);
  const [receiptDetails, setReceiptDetails] = useState({
    amount: 0,
    usdAmount: 0,
    asset: "",
    assetName: "",
    toAddress: "",
    txId: "",
    date: new Date().toLocaleDateString(),
    time: new Date().toLocaleTimeString(),
  });

  // Timer for resend button
  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // Get data from location state
  useEffect(() => {
    if (location.state) {
      const { transferData, userEmail, coinAmount, usdAmount, assetName, price } = location.state;
      
      if (transferData) {
        setTransferData(transferData);
        // Pre-populate receipt details from the transfer data
        setReceiptDetails({
          amount: coinAmount || transferData.amount,
          usdAmount: usdAmount || (coinAmount * price),
          asset: transferData.asset,
          assetName: assetName || transferData.asset.toUpperCase(),
          toAddress: transferData.toAddress,
          txId: transferData.transferId,
          date: new Date().toLocaleDateString(),
          time: new Date().toLocaleTimeString(),
        });
      }
      
      if (userEmail) {
        setUserEmail(userEmail);
        localStorage.setItem("userEmail", userEmail);
      } else {
        const savedEmail = localStorage.getItem("userEmail");
        if (savedEmail) {
          setUserEmail(savedEmail);
        }
      }
    } else {
      // If no state data, redirect back
      navigate("/dashboard");
    }
  }, [location, navigate]);

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next input
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }

    // Auto focus previous input on backspace
    if (!value && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    
    if (/^\d{6}$/.test(pastedData)) {
      const otpArray = pastedData.split("").slice(0, 6);
      setOtp(otpArray);
      setTimeout(() => {
        document.getElementById(`otp-5`).focus();
      }, 0);
    }
  };

  const handleSubmit = async () => {
    const otpCode = otp.join("");

    if (otpCode.length !== 6) {
      setPopup({ show: true, message: "Please enter complete 6-digit code", success: false });
      return;
    }

    if (!transferData) {
      setPopup({ show: true, message: "Transfer data not found", success: false });
      return;
    }

    setIsLoading(true);
    try {
      const res = await API.post(
        "/transfer/verify-otp",
        {
          otp: otpCode,
          transferId: transferData.transferId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setCompletedTransfer(res.data.data);
      
      // Update receipt details with actual transfer data from response
      if (res.data.data) {
        setReceiptDetails(prev => ({
          ...prev,
          txId: res.data.data._id || prev.txId,
          status: res.data.data.status || "completed",
        }));
      }
      
      // DIRECTLY SHOW RECEIPT AFTER SUCCESSFUL VERIFICATION
      setShowReceipt(true);

    } catch (error) {
      setPopup({
        show: true,
        message: error.response?.data?.error || "Invalid or expired OTP",
        success: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (!transferData) {
      setPopup({ show: true, message: "Transfer data not found", success: false });
      return;
    }

    // Check if timer is active
    if (resendTimer > 0) {
      setPopup({
        show: true,
        message: `Please wait ${resendTimer} seconds before requesting again`,
        success: false,
      });
      return;
    }

    setIsLoading(true);
    try {
      console.log("🔄 Resending OTP for transfer:", transferData.transferId);
      
      const response = await API.post(
        "/transfer/resend-otp",
        {
          transferId: transferData.transferId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log("✅ Resend OTP response:", response.data);

      // Show success message - BUT DO NOT REDIRECT
      setPopup({
        show: true,
        message: response.data.message || "New OTP sent to your email",
        success: true,
      });

      // Start 60 second timer
      setResendTimer(60);

      // Clear OTP inputs for new code
      setOtp(["", "", "", "", "", ""]);
      
      // Focus first input
      setTimeout(() => {
        document.getElementById(`otp-0`)?.focus();
      }, 100);

    } catch (error) {
      console.error("❌ Resend OTP error:", error);
      
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          "Failed to resend OTP. Please try again.";
      
      setPopup({
        show: true,
        message: errorMessage,
        success: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewTransaction = () => {
    if (completedTransfer && completedTransfer._id) {
      navigate(`/transaction/${completedTransfer._id}`);
    } else if (transferData && transferData.transferId) {
      navigate(`/transaction/${transferData.transferId}`);
    } else {
      navigate("/dashboard");
    }
  };

  const handleClosePopup = () => {
    setPopup({ ...popup, show: false });
    // DO NOT navigate to dashboard - stay on OTP page
  };

  // If showReceipt is true, directly show the receipt (no OTP input)
  if (showReceipt) {
    const assetIcon = coinIcons[receiptDetails.asset] || coin;
    const formattedAmount = receiptDetails.amount.toFixed(8);
    const formattedUsdAmount = formatCurrency(receiptDetails.usdAmount);

    return (
      <>
        <div className="btc-send-page">
          <div className="btc-send-logo">
            <img src={logo} alt="logo" />
          </div>

          <div className="stx-popup-overlay">
            <div className="stx-popup stx-success">
              <div className="stx-icon-box stx-success">
                <svg viewBox="0 0 100 100" className="stx-icon">
                  <circle cx="50" cy="50" r="45" className="stx-circle" />
                  <path
                    className="stx-path"
                    d="M30 52 L45 65 L70 38"
                  />
                </svg>
              </div>

              <h2 className="stx-popup-title">
                Transaction Successful!
              </h2>

              <p className="stx-popup-text">
                Your amount will be credited after successful network confirmation
              </p>

              <button
                className="stx-popup-btn"
                onClick={handleViewTransaction}
              >
                View Transaction
              </button>
            </div>
          </div>
        </div>
        
        <WhatsAppFloat 
          phoneNumber="15485825756"
          message="Hello! I need assistance with transfer verification on InstaCoinXPay."
          position="right"
          bottom="30px"
          right="30px"
          pulseEffect={true}
        />
      </>
    );
  }

  // Original OTP input page
  return (
    <>
      <div className="transfer-successful-container">
        <div className="transfer-successful-card">
          <span className="transferotp-back" onClick={() => navigate(-1)}>←</span> 
          
          <div className="transfer-successful-logo">
            <img src={logo} alt="logo" />
          </div>

          <div className="transfer-successful-coin-wrapper">
            <img src={coin} alt="bitcoin" />
          </div>

          <h2 className="transfer-successful-title">Transfer Verification</h2>
          <p className="transfer-successful-text">
            We have sent the verification code <br />
            to your email address. Please check your Spam or Junk folder if it doesn't appear shortly.
          </p>

          {/* Email display */}
          {userEmail && (
            <p className="transfer-successful-email">
              <strong>Email:</strong> {userEmail}
            </p>
          )}

          {/* OTP Inputs */}
          <div 
            className="transfer-successful-otp-boxes" 
            onPaste={handlePaste}
          >
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                autoFocus={index === 0}
                disabled={isLoading}
              />
            ))}
          </div>

          <button 
            className="transfer-successful-submit-btn" 
            onClick={handleSubmit}
            disabled={isLoading || otp.join("").length !== 6}
          >
            {isLoading ? "Verifying..." : "Verify & Complete Transfer"}
          </button>

          <p className="transfer-successful-resend-text">
            Didn't receive code?{" "}
            <button 
              className="transfer-successful-resend-btn" 
              onClick={handleResendCode}
              disabled={isLoading || resendTimer > 0}
            >
              {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend Code"}
            </button>
          </p>
        </div>

        {/* ANIMATED POPUP */}
        {popup.show && (
          <div className="transfer-successful-popup-overlay">
            <div className="transfer-successful-popup-card">
              <div className={`transfer-successful-icon-box ${popup.success ? "success" : "error"}`}>
                <svg viewBox="0 0 100 100" className="transfer-successful-icon">
                  <circle cx="50" cy="50" r="45" className="transfer-successful-circle" />
                  <path
                    className="transfer-successful-path"
                    d={
                      popup.success
                        ? "M30 52 L45 65 L70 38"
                        : "M35 35 L65 65 M65 35 L35 65"
                    }
                  />
                </svg>
              </div>

              <p className="transfer-successful-popup-text">{popup.message}</p>

              <button
                className="transfer-successful-ok-btn"
                onClick={handleClosePopup}
                disabled={isLoading}
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
      
      <WhatsAppFloat 
        phoneNumber="15485825756"
        message="Hello! I need assistance with transfer verification on InstaCoinXPay."
        position="right"
        bottom="30px"
        right="30px"
        pulseEffect={true}
      />
    </>
  );
};

export default Transferotp;